export default function Privacidad() {
  return (
    <div className="perfil-page" style={{ padding: '24px 20px', maxWidth: 640, margin: '0 auto' }}>
      <button className="btn-secundario" onClick={() => { window.location.href = '/' }}>
        ← Volver
      </button>

      <div className="page-header" style={{ marginTop: 20 }}>
        <h1 className="page-titulo">Política de privacidad</h1>
        <p className="page-subtitulo">Juco — última actualización: julio 2026</p>
      </div>

      <div style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--texto, #333)' }}>
        <p><strong>Qué datos recolectamos.</strong> Al crear una cuenta guardamos tu email y nombre. Según qué secciones uses, también podés guardar voluntariamente: peso y medidas corporales, fotos de progreso, hábitos diarios (sueño, agua, ejercicio, suplementos, comidas), notas personales, y tus recetas favoritas o realizadas.</p>

        <p><strong>Para qué los usamos.</strong> Únicamente para brindarte las funciones de la app: mostrarte tu propio historial, progreso y contenido guardado. No usamos tus datos para publicidad ni los vendemos a terceros.</p>

        <p><strong>Dónde se almacenan.</strong> Toda la información se guarda en Supabase, nuestro proveedor de infraestructura, con conexión cifrada (HTTPS) y reglas de acceso que garantizan que cada persona solo puede ver y modificar sus propios datos — ni siquiera el equipo de Juco puede ver el diario o el progreso de otro usuario a través de la app.</p>

        <p><strong>Con quién se comparte.</strong> No compartimos tu información con terceros, salvo el proveedor de infraestructura (Supabase) que la aloja de forma segura en nuestro nombre.</p>

        <p><strong>Cuánto tiempo la conservamos.</strong> Mientras tu cuenta esté activa. Podés pedir su eliminación en cualquier momento (ver abajo).</p>

        <p><strong>Tus derechos.</strong> De acuerdo a la Ley 25.326 de Protección de Datos Personales de Argentina, tenés derecho a acceder, rectificar y suprimir tus datos personales.</p>

        <p><strong>Cómo eliminar tu cuenta y tus datos.</strong> Podés hacerlo vos mismo/a desde la app, en Perfil → Eliminar cuenta. Si no tenés acceso a la app, podés pedirlo desde <a href="/borrar-cuenta">esta página</a> con tu email — lo procesamos en los días siguientes y te confirmamos por correo.</p>

        <p><strong>Sobre el contenido de salud.</strong> Juco es una herramienta de organización y acompañamiento de hábitos. No reemplaza el seguimiento de un profesional de la salud o la nutrición.</p>

        <p><strong>Contacto.</strong> Para cualquier consulta sobre tus datos, escribinos a <a href="mailto:soporte@juco.app">soporte@juco.app</a>.</p>
      </div>
    </div>
  )
}
